import { render } from "./loginView.vue?vue&type=template&id=fb4d3bb0&scoped=true"
import script from "./loginView.vue?vue&type=script&lang=js"
export * from "./loginView.vue?vue&type=script&lang=js"

import "./loginView.vue?vue&type=style&index=0&id=fb4d3bb0&scoped=true&lang=css"

import exportComponent from "/Users/tommygrimm/PhpstormProjects/testportal.20north.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb4d3bb0"]])

export default __exports__